/**
 * mulberry32, expressed as a pure state transition rather than a closure.
 *
 * A closure would hide the generator's position inside a function object,
 * which cannot be carried in GameState — and a replay that cannot restore
 * RNG position is not a replay. Every draw returns the next state explicitly.
 *
 * Math.imul and IEEE-754 division are exactly specified in ECMAScript, so
 * this produces identical output in the browser and in Node.
 */
export function nextRand(state: number): { value: number; state: number } {
  let a = (state + 0x6d2b79f5) >>> 0;
  let t = a;
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  const value = ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  return { value, state: a };
}

/** Integer in [0, n). */
export function randInt(state: number, n: number): { value: number; state: number } {
  const r = nextRand(state);
  return { value: Math.floor(r.value * n), state: r.state };
}
